var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-select',{attrs:{"allow-clear":false,"filter-option":false,"label-in-value":false,"mode":"multiple","options":_vm.options,"show-search":false,"max-tag-count":2,"placeholder":"全部级别"},on:{"change":_vm.change},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})
}
var staticRenderFns = []

export { render, staticRenderFns }